import * as tslib_1 from "tslib";
import * as React from 'react';
import OWADatePicker from 'owa-datepicker';
import { lazyScheduleItems } from 'owa-mail-triage-action';
import { morningDate } from 'owa-mail-list-context-menu/lib/helpers/createScheduleSubMenu';
import { observer } from 'mobx-react';
var ScheduleDatePicker = /** @class */ (function (_super) {
    tslib_1.__extends(ScheduleDatePicker, _super);
    function ScheduleDatePicker() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ScheduleDatePicker.prototype.render = function () {
        var _this = this;
        return (React.createElement(OWADatePicker, { isRequired: false, placeholder: "Choose a Date...", allowTextInput: true, minDate: new Date(), borderless: true, isMonthPickerVisible: false, onSelectDate: function (date) {
                _this.onDateSelection(date, _this.props.rowKeys, _this.props.tableView, _this.props.actionSource, _this.props.dismissMenu);
            } }));
    };
    ScheduleDatePicker.prototype.onDateSelection = function (date, rowKeys, tableView, actionSource, dismissMenu) {
        if (!date) {
            return;
        }
        date = morningDate(date);
        lazyScheduleItems.importAndExecute(rowKeys, tableView, actionSource, false, date);
        dismissMenu(null /* event */, true /* dismissAll */);
    };
    ScheduleDatePicker = tslib_1.__decorate([
        observer
    ], ScheduleDatePicker);
    return ScheduleDatePicker;
}(React.Component));
export default ScheduleDatePicker;
//# sourceMappingURL=ScheduleDatePicker.js.map